export const cloneNodeDeep = (node: any) => JSON.parse(JSON.stringify(node || {}));

export const toSafeNumber = (value: any, fallback = 0) => {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : fallback;
};

// 根据来源/目标分组节点的位置，重新计算状态节点及其文本在目标图层中的坐标
export const adjustStateNodePositionsForTargetLayer = (
  stateNodes: any[],
  sourceParentNode?: any,
  targetParentNode?: any
) => {
  if (!stateNodes.length) return [];
  const clonedStates = stateNodes.map(state => cloneNodeDeep(state));
  if (!sourceParentNode || !targetParentNode) {
    return clonedStates;
  }

  const sourceX = toSafeNumber(sourceParentNode.x);
  const sourceY = toSafeNumber(sourceParentNode.y);
  const targetX = toSafeNumber(targetParentNode.x);
  const targetY = toSafeNumber(targetParentNode.y);

  return clonedStates.map(state => {
    const stateX = toSafeNumber(state.x, sourceX);
    const stateY = toSafeNumber(state.y, sourceY);
    const offsetX = stateX - sourceX;
    const offsetY = stateY - sourceY;
    const nextX = targetX + offsetX;
    const nextY = targetY + offsetY;

    let nextText = state.text;
    if (state.text && typeof state.text === 'object') {
      const textX = toSafeNumber(state.text.x, stateX);
      const textY = toSafeNumber(state.text.y, stateY);
      const textOffsetX = textX - stateX;
      const textOffsetY = textY - stateY;
      nextText = {
        ...state.text,
        x: nextX + textOffsetX,
        y: nextY + textOffsetY,
      };
    }
    return {
      ...state,
      x: nextX,
      y: nextY,
      text: nextText,
    };
  });
};
